import { createStore } from 'vuex'
import auth from './modules/auth'
import companies from './modules/companies'

export default createStore({
  state: {
    loading: false,
    currentCompany: null,
    showCreateCompany: false,
    showWelcomeCompany: false
  },
    mutations: {
        setLoading(state, loading) {
            state.loading = loading
        },
        SET_CURRENT_COMPANY(state, company) {
            state.currentCompany = company
        },
        SET_SHOW_CREATE_COMPANY(state, show) {
            state.showCreateCompany = show
        },
        SET_SHOW_WELCOME_COMPANY(state, show) {
            state.showWelcomeCompany = show
        }
    },
  getters: {
    showCreateCompany: state => state.showCreateCompany,
    showWelcomeCompany: state => state.showWelcomeCompany
  },
    actions: {
    },
    modules: {
        auth,
        companies
    }
}) 